import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=2f7ac5cc&scoped=true&"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js&"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=2f7ac5cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ac5cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
